import { render, staticRenderFns } from "./ImportsUsedProductsList.vue?vue&type=template&id=378c4f8c&"
import script from "./ImportsUsedProductsList.vue?vue&type=script&lang=js&"
export * from "./ImportsUsedProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports